/**
 * Plugin to automatically "ajaxify" the cart
 */

(function ($) {
  var methods = {
    settings: {
      shopCurrency: window.shop.shopCurrency,
      moneyFormat: window.shop.moneyFormat
    },

    init: function() {
      this.find('.item-quantity input').on('change', $.proxy(methods.updateLine, this));
      this.find('#cart-note').on('change', $.proxy(methods.updateCartNote, this));
    },

    /**
     * @param event
     */
    updateLine: function(event) {
      var elem = $(event.currentTarget),
          moneyFormat = methods.settings['moneyFormat'],
          shopCurrency = methods.settings['shopCurrency'],
          variantId = parseInt(elem.attr('data-variant-id')),
          newCurrency = $('[name=currencies]').val() || shopCurrency,
          newQuantity = elem.val();

      if (parseInt(newQuantity) === 0) {
        // If we have no products, we don't want to trigger an Ajax call otherwise it would remove it from the cart.
        // Therefore we set it back to 1 and return
        elem.val('1');
        return;
      }

      Shopify.changeItem(variantId, newQuantity, function(result) {
        // We need to update the price on the line AND on the total result
        var line = $('.cart-items tr[data-variant-id=' + variantId + ']'),
            total = $('.cart-total .money');

        // Extract the line in the response
        for (var i = 0 ; i != result['items'].length ; ++i) {
          var currentLine = result['items'][i];

          if (currentLine['variant_id'] === variantId) {
            line.find('.item-line-price .money')
              .html(Shopify.formatMoney(currentLine['line_price'], moneyFormat))
              .attr('data-currency', shopCurrency)
              .removeAttr('data-currency-' + newCurrency.toLowerCase());

            break;
          }
        }

        // We need to update the currency in order to trigger a conversion
        total.html(Shopify.formatMoney(result['total_price'], moneyFormat))
          .attr('data-currency', shopCurrency)
          .removeAttr('data-currency-' + newCurrency.toLowerCase());

        Currency.convertAll(shopCurrency, $('[name=currencies]').val());
      });
    },

    /**
     * @param event
     */
    updateCartNote: function(event) {
      var elem = $(event.currentTarget);
      Shopify.updateCartNote(elem.val(), function(cart) {});
    }
  };

  $.fn.cartAjaxify = function(options) {
    return methods.init.call(this, options);
  };
}(jQuery));
/**
 * Plugin to automatically "featurify" an image
 */

(function ($) {
  var methods = {
    /**
     * @type {Object}
     */
    settings: {
      enableZoom: false, // Allow to enable zoom whenever we hover on an image
      listSelector: '.thumbnail-list', // List that holds the link to thumbnails
      magnify: 1,
      triggerEvent: "click" // Event that trigger the change
    },

    init: function() {
      // Enable the zoom on hover (by using the large image)
      if (methods.settings.enableZoom) {
        this.find('.image-featured').each(function (index, item) {
          var element = $(item);

          if (element.attr('data-fancybox-type') === 'image') {
            element.zoom({
              url: element.attr('href'),
              magnify: methods.settings.magnify
            });
          }
        });
      }

      // We attach a listener for each image in the thumbnail list to change the featured image
      $(methods.settings.listSelector).find('a').on(methods.settings.triggerEvent, $.proxy(methods.updateFeatured, this));
    },

    /**
     * @param event
     */
    updateFeatured: function(event) {
      var target = $(event.currentTarget),
          active = this.find('li.active'),
          imageId = target.attr('data-id');

      // If the settings is to change picture on click, we do not want to trigger the lightbox, so we need to
      // stop propagation, UNLESS the image the user is clicking is the same
      if (methods.settings.triggerEvent === 'click' && target.attr('data-id') !== active.attr('data-image-id')) {
        event.stopPropagation();
        event.preventDefault();
      }

      // We need to switch the image
      this.find('li').removeClass('active')
        .filter('[data-image-id=' + imageId + ']').addClass('active');
    }
  };

  $.fn.featurify = function(options) {
    return methods.init.call(this, options);
  };
}(jQuery));
/**
 * Plugin to automatically "ajaxify" the product
 */

(function ($) {
  var methods = {
    /**
     * @type {Object}
     */
    settings: {
      addToCartLabel: "Add To Cart",
      addingToCartLabel: "Adding To Cart...",
      addedToCartLabel: "Product was added!"
    },

    init: function() {
      // Replace the labels if we are in the "pre-order" template
      if (window.shop.template === 'product.pre-order') {
        methods.settings = {
          addToCartLabel: "Pre-Order",
          addingToCartLabel: "Pre-Ordering...",
          addedToCartLabel: "Product was pre-orderd!"
        };
      }

      this.on('click', $.proxy(methods.addProduct, this));

      Shopify.onError = $.proxy(methods.error, this);
      Shopify.onItemAdded = $.proxy(methods.added, this);
      Shopify.onCartUpdate = $.proxy(methods.cartUpdated, this);
    },

    /**
     * @param event
     */
    addProduct: function(event) {
      // First step, we change the content to the "addingToCartLabel"
      this.text(methods.settings['addingToCartLabel']);
      this.attr('disabled', 'disabled');
      this.addClass('loading');

      Shopify.addItemFromForm('add-to-cart-form');

      return false;
    },

    /**
     * @param response
     */
    added: function(response) {
      this.text(methods.settings['addedToCartLabel']);
      this.removeClass('loading').addClass('success');

      $('.added-to-cart-links').show();

      // We also need to update the cart info
      Shopify.getCart();

      setTimeout($.proxy(methods.revertDefaults, this), 2500);
    },

    /**
     * @param response
     */
    error: function(response) {
      this.text(response.responseJSON.description);
      this.removeClass('loading').addClass('error');

      setTimeout($.proxy(methods.revertDefaults, this), 2500);
    },

    /**
     *
     */
    revertDefaults: function() {
      this.text(methods.settings['addToCartLabel']);
      this.removeClass('error loading success');
      this.removeAttr('disabled');
    },

    /**
     * @param response
     */
    cartUpdated: function(response) {
      $('.cart-item-count').text(response['item_count']);
    }
  };

  $.fn.productAjaxify = function(options) {
    return methods.init.call(this, options);
  };
}(jQuery));


/**
 * JQuery Pick (used to display related products)
 */
(function( $ ){
  $.fn.pick = function(count) {

    var howMany = count || 4;

    // Picking random numbers without repeating.
    var index_array = [];
    var original_obj_size = this.size();
    for (var i=0; i<original_obj_size; i++) {
      index_array.push(i);
    }
    //+ Jonas Raoni Soares Silva
    //@ http://jsfromhell.com/array/shuffle [rev. #1]
    var shuffle = function(v) {
      for (var j, x, i = v.length; i; j = parseInt(Math.random() * i), x = v[--i], v[i] = v[j], v[j] = x);
      return v;
    };
    var new_index_array = shuffle(index_array).slice(0,howMany);

    // Ditching unpicked elements and removing those from the returned set.
    return this.each(function(i) {
      if ($.inArray(i,new_index_array) === -1) {
        $(this).remove();
      }
    }).filter(function() {
      if (this.parentNode === null) {
        return false;
      }
      else {
        return true;
      }
    });

  };
})( jQuery );
/**
 * Callback that automatically updates the variant
 */

window.maestroooProduct = function(options) {
  var variant = options['variant'],
      context = $('[data-product-id="' + options['productId'] + '"]'),
      offers = context.find('.product-offer'),
      inventory = context.find('.variant-inventory-quantity'),
      optionsContainer = context.find('.product-options'),
      labelsContainer = offers.find('.product-labels'),
      pricesContainer = offers.find('.product-prices');

  // We remove all the things that may change
  inventory.hide();
  pricesContainer.find('.price, .sale-percent').remove().end();
  labelsContainer.find('.product-label').show();
  labelsContainer.find('.sold-out-label, .unavailable-label').hide();
  optionsContainer.find('.button-add-to-cart-container').show();
  optionsContainer.find('.back-in-stock').hide();

  // There are a lot of things we need to change... so let's start!
  if (variant) {
    // This one allows to check the right color if swatch are used
    for (var i = 0 ; i < variant.options.length ; i++) {
      var radioButtonValue = variant.options[i].replace(/([!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~])/g,'\\\\$1');
      var radioButton = context.find('.swatch[data-option-index="' + i + '"]').find(':radio[value="' + radioButtonValue + '"]');

      if (radioButton.size()) {
        radioButton.closest('.swatch-element').addClass('active');
        radioButton.get(0).checked = true;
      }
    }

    if (!variant['available']) {
      // If variant only is not available... we show the sold out label, and hide the "Add to Cart" button
      labelsContainer.find('.sold-out-label').css('display', 'inline-block');
      optionsContainer.find('.button-add-to-cart-container').hide();
      optionsContainer.find('.back-in-stock').show();
    } else {
      var price = Shopify.formatMoney(variant['price'], options.moneyFormat),
          compareAtPrice = Shopify.formatMoney(variant['compare_at_price'], options['moneyFormat']);

      if (variant['compare_at_price'] > variant['price']) {
        var percentDrop = (variant['compare_at_price'] - variant['price']) / variant['compare_at_price'] * 100;

        pricesContainer.prepend('<span class="new-price price money">' + price + '</span>')
          .prepend('<span class="old-price price money">' + compareAtPrice + '</span>');

        if (percentDrop > 0) {
          pricesContainer.append('<span class="sale-percent">' + -Math.round(percentDrop) + '%</span>');
        }
      } else {
        pricesContainer.prepend('<span class="price money">' + price + '</span>');
      }
    }

    // We need to update the quantity
    if (inventory.length > 0 && variant['inventory_management'] !== null) {
      inventory.find('.count').text(variant['inventory_quantity']).end().show();
    }

    // If the variant has a featured image associated with it, we need to modify the featured image
    if (variant['featured_image']) {
      $('.product-showcase .featured-image-list li').removeClass('active')
        .filter('[data-image-id=' + variant['featured_image']['id'] + ']')
        .addClass('active');
    }
  } else {
    // This is an unavailable variant, so we need to hide the "add to cart" button, and show the "unavailable" label
    optionsContainer.find('.button-add-to-cart-container').hide();
    labelsContainer.find('.product-label').hide().end().find('.unavailable-label').css('display', 'inline-block');
  }

  Currency.convertAll(options['shopCurrency'], $('[name=currencies]').val());
};
var router = new RouterRouter();

/**
 * ----------------------------------------------------------------------------------------------------
 * ACCOUNT ADDRESSES ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('account/addresses', function() {
  /**
   * -------------------------
   * INIT ADDRESS SELECTOR
   * -------------------------
   */

  new Shopify.CountryProvinceSelector('address_country_new', 'address_province_new', {hideElement: 'address-province-container-new'});
});
/**
 * ----------------------------------------------------------------------------------------------------
 * ACCOUNT LOGIN ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('account/login', function() {
  var switchToReset = function() {
    $('.login-form, .recover-password-form').toggle();
    $('.page-title').html("Recover your Password");
  };

  // When we submit a reset password, Shopify redirects to the login page, but with the "#recover" hash
  if (window.location.hash === '#recover') {
    switchToReset();
  }

  $('.forgot-password-link').on('click', function() {
    switchToReset();
  });
});
/**
 * ----------------------------------------------------------------------------------------------------
 * CODE EXECUTED FOR EACH ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('*all', function() {
  // Is used to eliminate 300ms delay on iOS
  FastClick.attach(document.body);

  if ($('html').hasClass('ie8')) {
    $('.fancybox.search-toggle').fancybox({
      minWidth: 400,
      topRatio: 0.3,
      wrapCSS: 'mega-search',
      afterShow: function () {
        $('#search-autocomplete').focus();
      }
    });
  } else {
    $('.fancybox.search-toggle').fancybox({
      minWidth: 400,
      topRatio: 0.3,
      wrapCSS: 'mega-search',
      afterShow: function() {
        $('#search-autocomplete').focus();
      },
      helpers : {
        overlay : {
          css : {
            'background' : 'rgba(0, 0, 0, 0.92)'
          }
        }
      }
    });
  }


  /**
   * -------------------------
   * MENU ON MOBILE
   * -------------------------
   */

  $('.header-mobile-nav .search-link').on('click', function() {
    $(this).next('.tab-content').find('input').focus();
  });

  $('.header-mobile-nav .mobile-nav-tabs > li a').on('click', function() {
    $(this).parent().siblings().removeClass('active').end().toggleClass('active');
  });

  $('.header-mobile-nav .see-more').on('click', function() {
    var elem = $(this),
        text = elem.html();

    elem.html(text === '<i class="icon-plus"></i>' ? '<i class="icon-minus"></i>' : '<i class="icon-plus"></i>');

    elem.closest('.dropdown').toggleClass('open');

    return false;
  });

  if (Modernizr.touch) {
    $('.header-desktop-nav .header-nav-links .is-nested > a, .header-desktop-nav .header-nav-links .is-sub-nested > a').on('click', function(event) {
      event.preventDefault();
    });
  }

  /**
   * -------------------------
   * AUTO-COMPLETION
   * -------------------------
   */
  
    $('#search-autocomplete').awesomecomplete({
      resultLimit: 50,
      typingDelay: 50,
      suggestionListClass: 'awesomecomplete',
      splitTerm: false,

      dataMethod: function(term, event, done) {
        $.ajax({
          url: '/search',
          dataType: 'json',
          data: {
            type: 'product',
            q: term + '*', // We automatically add wildcard for partial matching
            view: 'json'
          }
        }).then(function(data) {
          done(data);
        });
      },

      sortFunction: function() {
        return 0;
      },

      renderFunction: function(result, term) {
        if (result['results_count'] !== undefined) {
          return '<a class="ac-results-count" href="' + result['url'] + '">' + "See all results"
            + ' (' + result['results_count'] + ')' + '</a>';
        }

        return '<a href="' + result['url'] + '"><img class="ac-product-image" src="' + result['thumbnail'] + '">'
          + '<div class="ac-product-info"><span class="ac-product-title">' + result['title'] + '</span>'
          + '<span class="ac-price-min">' + "Starting at" + ' ' + result['price_min'] + '</span></div></a>';
      },

      onComplete: function(dataItem) {
        location.href = dataItem['url'];
      }
    });
  

  /**
   * -------------------------
   * AUTOMATIC CURRENCY CONVERSION
   * -------------------------
   */

  

  /**
   * -------------------------
   * QUICK SHOP
   * -------------------------
   */

  
    $('.quick-shop-button.fancybox').fancybox({
      wrapCSS: 'quick-shop',
      minWidth: 900
    });
  

  /**
   * -------------------------
   * BACK TO TOP BUTTON
   * -------------------------
   */

  
    var backToTopOffset = 300,
        backToTopDuration = 500;

    $(window).on('scroll', function() {
      if ($(this).scrollTop() > backToTopOffset) {
        $('#back-to-top').fadeIn(backToTopDuration);
      }
      else {
        $('#back-to-top').fadeOut(backToTopDuration);
      }
    });

    $('#back-to-top').off('click.smoothscroll').on('click', function(e) {
      e.preventDefault();
      $('html, body').animate( { scrollTop: 0 }, backToTopDuration);

      return false;
    });
  

  /**
   * -------------------------
   * MARKETING POPUP
   * -------------------------
   */

  
});
/**
 * ----------------------------------------------------------------------------------------------------
 * COLLECTION ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('cart', function() {
  var cart = $('#cart');

  /**
   * -------------------------
   * AJAXIFY THE CART
   * -------------------------
   */

  cart.cartAjaxify();

  /**
   * -------------------------
   * TERMS AND CONDITIONS CHECKBOX
   * -------------------------
   */

  

  /**
   * -------------------------
   * SHIPPING ESTIMATOR
   * -------------------------
   */

  
    Shopify.Cart.ShippingCalculator.show({
      submitButton: "Estimate",
      submitButtonDisabled: "Estimating...",
      customerIsLoggedIn: window.shop.customerIsLogged,
      shopCurrency: window.shop.shopCurrency,
      moneyFormat: window.shop.moneyWithCurrencyFormat
    });
  
});
/**
 * ----------------------------------------------------------------------------------------------------
 * COLLECTION ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('collections/*type', function() {
  /**
   * -------------------------
   * SORT BY
   * -------------------------
   */

    Shopify.queryParams = {};

    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');

        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }

    $('#sort-by').val(Shopify.queryParams['sort_by'] || window.shop.collectionDefaultSortBy || 'manual')
      .on('change', function() {
        Shopify.queryParams.sort_by = $(this).val();
        location.search = decodeURIComponent($.param(Shopify.queryParams));
      });

    $('.styled-select.filters select').on('change', function(event) {
      window.location.href = $(event.currentTarget).find(':selected').val();
    });

  /**
   * -------------------------
   * PAGINATION MODE
   * -------------------------
   */

  
    $('.product-list').infiniteScrollHelper({
      loadingClassTarget: '.infinite-scrolling-loader',
      startingPageCount: window.shop.currentPage,
      hasMore: true,

      loadMore: function(page, done) {
        var loadingTarget = $(this.loadingClassTarget);

        if (!this.hasMore || loadingTarget.length == 0) {
          done();
          return;
        }

        var targetUrl = $.query.load(loadingTarget.attr('data-next-page'));

        // We need to modify the "page" attribute of the fetched URL
        targetUrl = targetUrl.set('page', page);

        $.ajax({
          url: location.protocol + '//' + location.host + location.pathname,
          data: targetUrl.toString().slice(1) // Allow to remove the initial "?" character
        }).then(function(content) {
          done();

          // Check if there is still content to load
          if (content.trim() == '') {
            $('.product-list').infiniteScrollHelper('destroy');
          } else {
            // We can append the content to the .product-list container
            $('.product-list').append(content);
          }
        });
      }
    });
  
});
/**
 * ----------------------------------------------------------------------------------------------------
 * INDEX ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('', function() {
  /**
   * -------------------------
   * SLIDER
   * -------------------------
   */

  
    $(window).load(function() {
      $('.flexslider').flexslider({
        animation: "slide",
        useCSS: true,
        smoothHeight: true,
        prevText: '',
        nextText: '',
        controlsContainer: '.flex-controls',
        controlNav: false,
        slideshow: false,
        slideshowSpeed: "12000",
        randomize: false
      });
    });
  

  /**
   * -------------------------
   * INSTAGRAM
   * -------------------------
   */

  
    

    

    
      var feed = new Instafeed({
        get: 'user',
        userId: 1612952580,
        accessToken: "1612952580.1677ed0.835d65a16e864be9b42e52e8615cf584",
        sortBy: 'most-recent',
        limit: 8,
        resolution: 'low_resolution',
        template: '<div class="picture-wrapper"><a href="{{link}}" target="_blank"><div class="overlay"></div><img src="{{image}}"/></a></div>'
      });
    

    feed.run();

  
});
/**
 * ----------------------------------------------------------------------------------------------------
 * INDEX ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('pages/instagram-feed', function() {
  /**
   * -------------------------
   * INSTAGRAM
   * -------------------------
   */

  
    

    

    
       var feed = new Instafeed({
         get: 'user',
         userId: 1612952580,
         accessToken: "1612952580.1677ed0.835d65a16e864be9b42e52e8615cf584",
         sortBy: 'most-recent',
         limit: 40,
         resolution: 'low_resolution',
         template: '<div class="picture-wrapper"><a href="{{link}}" target="_blank"><div class="overlay"></div><img src="{{image}}"/></a></div>'
       });
    

    feed.run();

  
});
/**
 * ----------------------------------------------------------------------------------------------------
 * PRODUCT QUICK SHOP ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

var productQuickShopRoute = function() {
  // We do this only on Quick Shop to avoid the fancybox to open for the quick shop, otherwise it would be
  // a popup inside the popup ^^.
  $('.image-featured').on('click', function() {
    return false;
  });
};
/**
 * ----------------------------------------------------------------------------------------------------
 * PRODUCT ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

var productRoute = function() {
  /**
   * -------------------------
   * ACTIVATE THINGS LIKE ZOOM AND UPDATE THE FEATURED IMAGE
   * -------------------------
   */
  $('.featured-image-list').featurify();

  /**
   * -------------------------
   * BACK IN STOCK
   * -------------------------
   */

  

  /**
   * -------------------------
   * COLOR SWATCH
   * -------------------------
   */

  
    $('.swatch-element').on('click', function() {
      var optionIndex = $(this).parents('.swatch').attr('data-option-index');
      var optionValue = $(this).children('[type="radio"]').val();
      var context = $(this).closest('form');

      $('.single-option-selector', context).eq(optionIndex).find('option').filter(function() {
        return $(this).text() == optionValue
      }).parent().val(optionValue).trigger('change');
    });
  

  /**
   * -------------------------
   * AJAX ADD TO CART
   * -------------------------
   */

  
    $('.button-add-to-cart').productAjaxify();
  

  /**
   * -------------------------
   * RELATED PRODUCTS
   * -------------------------
  */

  
    
    var relatedProducts = $('.related-products li');
    relatedProducts.pick(3);
    relatedProducts.show();

    $('.related-products li:nth-child(3n+1)').addClass('first');
  

    /**
   * -------------------------
   * FANCYBOX (LIGHTBOX)
   * -------------------------
   */

  $('.image-showcase.fancybox').fancybox({
    openEffect  : 'fade',
    closeEffect : 'fade',
    nextEffect  : 'fade',
    prevEffect  : 'fade',
    wrapCSS     : 'image-showcase-fancybox',
    topRatio    : 0.2,
    padding     : 0,
    margin      : [20, 60, 150, 60],
    helpers : {
      overlay : {
        css : {
          'background' : 'rgba(0, 0, 0, 0.9)'
        }
      },
      title: null
    },
    afterLoad: function() {
      var list = $('#product-showcase-links');

      if (!list.length) {
        list = $('<ul id="product-showcase-links">');

        for (var i = 0; i < this.group.length; i++) {
          var thumbnail = this.group[i].element.attr('data-thumbnail'),
              html = '<li data-index="' + i + '"><div class="overlay"></div><img src="' + thumbnail + '"></li>';

          $(html).click(function() {
            $.fancybox.jumpto($(this).data('index'));
          }).appendTo(list);
        }

        list.appendTo('body');
      }

      list.find('li').removeClass('active').eq(this.index).addClass('active');
    },
    beforeClose: function() {
      $('#product-showcase-links').remove();
    }
  });
};

router.route('products/*type', productRoute);
router.route('collections/*collection/products/*type', productRoute);
/**
 * ----------------------------------------------------------------------------------------------------
 * SEARCH ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('search', function() {
  /**
   * -------------------------
   * PAGINATION MODE
   * -------------------------
   */

  
    $('.product-list').infiniteScrollHelper({
      loadingClassTarget: '.infinite-scrolling-loader',
      startingPageCount: window.shop.currentPage,
      hasMore: true,

      loadMore: function(page, done) {
        var loadingTarget = $(this.loadingClassTarget);

        if (!this.hasMore || loadingTarget.length == 0) {
          done();
          return;
        }

        var targetUrl = $.query.load(loadingTarget.attr('data-next-page'));

        // We need to modify the "page" attribute of the fetched URL
        targetUrl = targetUrl.set('page', page);

        $.ajax({
          url: location.protocol + '//' + location.host + location.pathname,
          data: targetUrl.toString().slice(1) // Allow to remove the initial "?" character
        }).then(function(content) {
          done();

          // Check if there is still content to load
          if (content.trim() == '') {
            $('.product-list').infiniteScrollHelper('destroy');
          } else {
            // We can append the content to the .product-list container
            $('.product-list').append(content);
          }
        });
      }
    });
  
});